module.exports = __webpack_public_path__ + "img/icon_euro.33f29c53.svg";